import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import SubscribePage from "./components/SubscribePage";
import VideoCentralPage from "./components/VideoCentralPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/soccerquiz" element={<SubscribePage />} />
        <Route path="/videocentral" element={<VideoCentralPage />} />
        <Route path="/" element={<Navigate to="/soccerquiz" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
